import { all, call, delay, fork, put, race, select, take, takeLatest } from 'redux-saga/effects';
import {
  loggedIn, notLoggedIn,
  refreshLoginStatus, loggedInUpdate,
  cancelRefreshLoginStatus,
  registered, notRegistered,
  refreshLoginStatusCancelled
} from '../actions/auth';
import api from '../api';
import { serverError } from '../actions/common';
import { getAuth } from '../reducers/auth';

export const refreshDelay = 400000;
export function* userLogin(action) {
  if (!action || !Object.hasOwn(action, 'data')) {
    yield put(serverError(['No required parameters']));
  }
  try {
    const user = yield call([api, api.login], action.data);
    if (user.statusCode === 200) {
      yield put(loggedIn(user));
      yield delay(refreshDelay);
      yield put(refreshLoginStatus());
    } else {
      yield put(notLoggedIn(user.messages));
    }
  } catch (e) {
    yield put(serverError([e.message]));
  }
}
export function* watchLoginRequest() {
  yield takeLatest('USER_LOGIN_REQUEST', userLogin);
}

export function* refreshLogin() {
  try {
    const loginStatus = yield call([api, api.session]);
    const authState = yield select(getAuth);
    const { isAdmin, name, isInitialized } = authState;
    if (loginStatus.statusCode === 200) {
      if (!isInitialized) {
        yield put(loggedIn(loginStatus));
      } else if (isAdmin !== loginStatus.isAdmin || name !== loginStatus.name) {
        yield put(loggedInUpdate(loginStatus));
      }
      const { cancel } = yield race({
        response: delay(refreshDelay),
        cancel: take('CANCEL_LOGGED_IN_UPDATE')
      });
      if (!cancel) {
        yield put(refreshLoginStatus());
      } else {
        yield put(refreshLoginStatusCancelled());
      }
    } else {
      if (!isInitialized) {
        yield put(notLoggedIn());
      } else {
        yield put(notLoggedIn(loginStatus.messages || [loginStatus.message]));
      }
    }
  } catch (e) {
    yield put(serverError([e.message]));
  }
}
export function* watchRefreshRequest() {
  yield takeLatest('REQUEST_LOGGED_IN_UPDATE', refreshLogin);
}

export function* userLogout() {
  try {
    const logoutStatus = yield call([api, api.logout]);
    if (logoutStatus.statusCode === 200) {
      yield put(notLoggedIn(logoutStatus.messages || [logoutStatus.message]));
      yield put(cancelRefreshLoginStatus());
    } else {
      yield put(serverError(logoutStatus.messages || ['Can\'t logout']));
    }
  } catch (e) {
    yield put(serverError([e.message]));
  }
}
export function* watchLogoutRequest() {
  yield takeLatest('USER_LOGOUT_REQUEST', userLogout);
}

export function* userRegister(action) {
  if (!action || !Object.hasOwn(action, 'data')) {
    yield put(serverError(['No required parameters']));
  }
  try {
    const registerStatus = yield call([api, api.register], action.data);
    if (registerStatus.statusCode === 200) {
      yield put(registered());
    } else {
      yield put(notRegistered(registerStatus.messages || [registerStatus.message]));
    }
  } catch (e) {
    yield put(serverError([e.message]));
  }
}

export function* watchRegisterRequest() {
  yield takeLatest('USER_REGISTER_REQUEST', userRegister);
}


export default function* authSaga() {
  yield all([
    fork(watchLoginRequest),
    fork(watchRefreshRequest),
    fork(watchLogoutRequest),
    fork(watchRegisterRequest)
  ]);
}
